import api from './api';

const unitsService = {
  all(payload) {
    return api.get(`/units?q=${payload['q'] || ''}`);
  },
  async show(id) {
    const response = await api.get(`/units/${id}`);
    return response.data.unit;
  },
  save(payload) {
    if (payload.id) {
      return api.put(`/units/${payload.id}`, payload);
    } else {
      return api.post('/units', payload);
    }
  },
  createUnitBed(unitId, payload) {
    return api.post(`/units/${unitId}/create_unit_beds`, payload);
  },
  availableUnitBeds(unitId) {
    return api.get(`/units/${unitId}/available_unit_beds`);
  },
  dashboard({ q }) {
    // return api.get(`/units/dashboard?q=${q || ''}`);
    return api.get(`/units?q=${q || ''}`);
  },
  bedTypes() {
    return api.get(`/units/unit_bed_types`);
  },
  delete(unitId) {
    return api.delete(`/units/${unitId}`);
  },
  deleteBed(unitId, bedId) {
    return api.delete(`/units/${unitId}/destroy_unit_bed?unit_bed_id=${bedId}`);
  },
  fetchRegulationUnits() {
    return api.get(`/units/units_for_regulation`);
  },
  fetchSolicitationUnits() {
    return api.get(`/units/units_for_solicitation`);
  }
};

export default unitsService;
